

































































import {
  getdatalist,
  adduser,
  getuserinfodata,
  changestate,
  getorglist,
} from "@/api/adminmanage";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "userinfo",
  components: {},
})
export default class extends Vue {
  mounted() {
    this.getdatainfo();
    // 防止浏览器后退
    history.pushState(null, "null", document.URL);
    window.addEventListener("popstate", function () {
      history.pushState(null, "null", document.URL);
    });
  }
  private aa = "";
  private addParms = {
    loginname: "",
    username: "",
    admincode: "",
    psd: "",
    isuse: 1,
    isdelete: 1,
    usertype: "",
    orgnizeid: "",
    id: "",
    copesd: "",
  };
  private loginname = "";
  private validatePass2(rule, value, callback) {
    if (value === "") {
      callback(new Error("请再次输入密码"));
    } else if (value !== this.addParms.psd) {
      callback(new Error("两次输入密码不一致!"));
    } else {
      callback();
    }
  }
  private rules = {
    loginname: [{ required: true, message: "请输入登录名", trigger: "blur" }],
    userorgizetype: [
      { required: true, message: "请选择角色类型", trigger: "change" },
    ],
    orgnizeid: [
      { required: true, message: "请选择所属关系", trigger: "change" },
    ],
    admincode: [
      { required: true, message: "请填写证件号码", trigger: "blur" },
      {
        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
        message: "证件号码格式有误！",
        trigger: "blur",
      },
    ],
    username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
    psd: [
      { required: true, message: "请输入密码", trigger: "blur" },
      { min: 1, message: "密码最少大于1位", trigger: "blur" },
    ],
    copesd: [
      {
        required: true,
        validator: this.validatePass2,
        trigger: "blur",
      },
    ],
  };
  private async getdatainfo() {
    let parm = sessionStorage.getItem("json");
    let parma: any = null;
    if (parm != null) {
      parma = JSON.parse(parm);
    }
    const params = {
      id: parma.userid,
    };
    await getuserinfodata(params).then((res) => {
      if (res.code === 200) {
        const data = res.data.items;
        this.addParms = {
          loginname: data.loginname,
          username: data.username,
          admincode: data.admincode,
          psd: data.psd,
          isuse: data.isues,
          isdelete: 1,
          usertype: data.usertype,
          orgnizeid: data.orgnizeid,
          id: data.id,
          copesd: data.psd,
        };
      }
    });
  }
  private getsession() {}
  private onSubmit() {
    const form = this.$refs.addParms as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        const params = {
          loginname: this.addParms.loginname,
          username: this.addParms.username,
          admincode: this.addParms.admincode,
          psd: this.addParms.psd,
          isuse: this.addParms.isuse,
          isdelete: 1,
          usertype: this.addParms.usertype,
          orgnizeid: this.addParms.orgnizeid,
          id: this.addParms.id,
        };
        await changestate(params).then((res: any) => {
          if (res.code === 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          let parm = sessionStorage.getItem("json");
          let parma: any = null;
          if (parm != null) {
            parma = JSON.parse(parm);
          }
          parma.name = this.addParms.username;
          sessionStorage.clear();
          sessionStorage.setItem("json", JSON.stringify(parma));
          this.$store.state.user.name = parma.name;
        });
      }
    });
  }
}
